import { $t } from '../../composables/i18n'
import CodebookValueNotFoundError from '../CodebookValueNotFoundError'

export enum GuestCategoryTypeId {
  MINOR = 1,
  STUDENT = 2,
  ADULT = 3,
  SENIOR = 4,
  OTHER = 5,
}

export class GuestCategoryType {
  static readonly MINOR = new GuestCategoryType(GuestCategoryTypeId.MINOR, () => $t('Minor'))
  static readonly STUDENT = new GuestCategoryType(GuestCategoryTypeId.STUDENT, () => $t('Student'))
  static readonly ADULT = new GuestCategoryType(GuestCategoryTypeId.ADULT, () => $t('Adult'))
  static readonly SENIOR = new GuestCategoryType(GuestCategoryTypeId.SENIOR, () => $t('Senior'))
  static readonly OTHER = new GuestCategoryType(GuestCategoryTypeId.OTHER, () => $t('Other'))

  private constructor(
    public readonly id: GuestCategoryTypeId,
    public readonly name: () => string,
  ) {}

  static getById = (id: GuestCategoryTypeId): GuestCategoryType => {
    const value = GuestCategoryType.all().find((item) => item.id === id)

    if (value === undefined) {
      throw new CodebookValueNotFoundError(GuestCategoryType.name, id)
    }

    return value
  }

  static all = (): GuestCategoryType[] => {
    return [
      GuestCategoryType.MINOR,
      GuestCategoryType.STUDENT,
      GuestCategoryType.ADULT,
      GuestCategoryType.SENIOR,
      GuestCategoryType.OTHER,
    ]
  }
}
